export default "__VITE_ASSET__QKgjKRmp__"